import ContractsTable from './ContractsTable';

export default ContractsTable;
